package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.screens.main.data.ButtonType
import com.eladfinish.bible.contest.screens.main.data.ButtonTypeSerializer
import kotlinx.serialization.modules.SerializersModule

val customSerializers by lazy {
    SerializersModule {
        contextual(kClass = ButtonType::class, serializer = ButtonTypeSerializer)
    }
}
